export default __webpack_public_path__ + "static/media/securedIcon.7c6cc74b.png";